import { render, staticRenderFns } from "./AiRedactor.vue?vue&type=template&id=60e27831"
import script from "./AiRedactor.vue?vue&type=script&lang=js"
export * from "./AiRedactor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports